<template>
  <div>
    <v-card class="mt-4 mb-6 pt-1 ra-rugl-card">
      <v-row>
        <v-col>
          <ra-card-info :test="test" />
        </v-col>
        <v-col class="mr-4">
          <rugl-card-info :test="test" />
        </v-col>
      </v-row>
    </v-card>
    <h4>{{ $t("room.illumination.ra.title") }}</h4>
    <niko-slider
      :label="$t('room.illumination.ra.measured')"
      :min="-1"
      :max="100"
      suffix="Ra"
      step="1"
      :value="measuredRa"
      placeholder="-"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'measured_ra',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
          debouncedSetMeasuredRa(value);
        }
      "
    />
    <h4>{{ $t("room.illumination.rugl.title") }}</h4>
    <niko-slider
      :label="$t('room.illumination.rugl.measured')"
      :min="-1"
      :max="40"
      step="1"
      :value="measuredRugl"
      placeholder="-"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'measured_rugl',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
          debouncedSetMeasuredRugl(value);
        }
      "
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import NikoSlider from "../../UI/NikoSlider";
import RaCardInfo from "./RaCardInfo.vue";
import RuglCardInfo from "./RuglCardInfo.vue";

export default {
  name: "tester-ra-rugl",
  components: { NikoSlider, RaCardInfo, RuglCardInfo },
  props: ["test", "index"],
  computed: {
    ...mapState("roomStore", ["room_id"]),
    measuredRa() {
      return this.test.measured_ra ?? null;
    },
    measuredRugl() {
      return this.test.measured_rugl ?? null;
    },
  },
  methods: {
    ...mapMutations("roomStore", ["changeIlluminationTestAttribute"]),
    ...mapActions("projectStore", ["setMeasuredRa", "setMeasuredRugl"]),
    debouncedSetMeasuredRa: debounce(function (value) {
      this.setMeasuredRa({
        illumination_test_id: this.test.illumination_test_id,
        measured_ra: value,
      });
    }, 500),
    debouncedSetMeasuredRugl: debounce(function (value) {
      this.setMeasuredRugl({
        illumination_test_id: this.test.illumination_test_id,
        measured_rugl: value,
      });
    }, 500),
  },
};
</script>

<style lang="scss">
.ra-rugl-card {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 4px;
  padding: 8px 22px;
}
</style>
